<template>
    <div class="lang-selector">
        <fieldset>
            <select
                v-model="selected"
                class="form-control lang-choice"
                data-role="select"
                data-filter="false"
                name="lang-choice"
                id="lang-choice"
            >
                <option
                    :value="key"
                    v-for="(name, key) in list"
                    :key="key"
                    :data-template="`<span class='iti-flag ${key === 'en' ? 'us' : key}'></span> $1`"
                    :selected="lang === key"
                >{{ name }}</option>
            </select>
            <label class="form-control-placeholder" for="lang-choice">{{ 'javascript.language' | trans }}</label>
        </fieldset>
    </div>
</template>

<script>
export default {
  name: 'Lang',
  props: {
    lang: String,
    list: Object
  },
  data () {
    return {
      selected: ''
    }
  },
  created () {
    this.selected = this.lang
  },
  watch: {
    selected (v, o) {
      if (v !== o) {
        this.$emit('select', v)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .lang-selector {
      .lang-choice {
          display: none !important;
      }
  }
</style>
